// @ts-nocheck
/**
 * @deprecated
 * Use the "AccountSettingsForm" widget instead.
 */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { hasChanges } from "@insite/client-framework/Store/Pages/AccountSettings/AccountSettingsSelectors";
import saveCurrentAccount from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

/* Greif Custom Code - Start */
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { hasAdditionalParamChanges } from "@store/Framework/Store/Greif/Pages/AccountSettings/AccountSettingsSelectors";
import setAdditionalAccountSettingsValues from "@store/Framework/Store/Greif/Pages/AccountSettings/Handlers/SetAdditionalAccountSettingsValues";

const enum fields {
    showCancelChangesButton = "showCancelChangesButton",
}
/* Greif Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    account: state.pages.accountSettings.editingAccount,
    isEmailValid: !state.pages.accountSettings.emailErrorMessage,
    hasChanges: hasChanges(state),
    useDefaultCustomer: state.pages.accountSettings.useDefaultCustomer,
    initialUseDefaultCustomer: state.pages.accountSettings.initialUseDefaultCustomer,
    hasAdditionalChange: hasAdditionalParamChanges(state), // Greif
    currentAccount: getCurrentAccountState(state).value, // Greif
});

const mapDispatchToProps = {
    saveCurrentAccount,
    setInitialValues,
    setAdditionalAccountSettingsValues, // Greif
};

/* Greif Custom Code - Start */
interface OwnProps extends WidgetProps {
    fields: {
        [fields.showCancelChangesButton]: boolean;
    };
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;
/* Greif Custom Code - End */

export interface AccountSettingsSubmitStyles {
    saveButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
}

export const accountSettingsStyles: AccountSettingsSubmitStyles = {
    cancelButton: { variant: "tertiary" }, // Greif
};

const styles = accountSettingsStyles;

const AccountSettingsSubmit = ({
    account,
    isEmailValid,
    hasChanges,
    useDefaultCustomer,
    saveCurrentAccount,
    setInitialValues,
    // Greif
    hasAdditionalChange,
    currentAccount,
    setAdditionalAccountSettingsValues,
    fields,
}: Props) => {
    const toasterContext = useContext(ToasterContext);

    if (!account) {
        return null;
    }

    const updateSettingsHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.preventDefault();
        saveCurrentAccount({
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Settings updated"), messageType: "success" });
            },
            onError: message => {
                toasterContext.addToast({ body: message, messageType: "warning" });
            },
        });
    };
    /* Greif Custome Code - Start */
    const resetSettings = () => {
        const accountProp = JSON.parse(currentAccount?.properties?.notificationsFollowed || " {}");
        const accountLanguage = currentAccount?.properties?.communicationLanguageId;
        setAdditionalAccountSettingsValues({
            followNewFeature: accountProp?.followNewFeature,
            followNewPrice: accountProp?.followNewPrice,
            followNewTec: accountProp?.followNewTec,
            followUpcomingShipment: accountProp?.followUpcomingShipment,
            followOrderShipped: accountProp?.followOrderShipped,
            followOrderPickup: accountProp?.followOrderPickup,
            followOrderChange: accountProp?.followOrderChange,
            language: accountLanguage,
        });
        setInitialValues();
    };
    /* Greif Custome Code - End */

    const invalidCustomerState = useDefaultCustomer && !account.defaultCustomerId;
    const enableSaveButton = (hasChanges || hasAdditionalChange) && isEmailValid && !invalidCustomerState; // Greif Custom Code

    return (
        <FormActions>
            <Button
                {...styles.saveButton}
                onClick={updateSettingsHandler}
                disabled={!enableSaveButton}
                data-test-selector="accountSettings_save"
            >
                {translate("Save")}
            </Button>
            {/* Greif Custom Code - Start */}
            {fields.showCancelChangesButton && (
                <Button
                    {...styles.cancelButton}
                    onClick={resetSettings}
                    disabled={!hasChanges && !hasAdditionalChange} /* Greif */
                >
                    {translate("Reset Changes")}
                </Button>
            )}
            {/* Greif Custom Code - End */}
        </FormActions>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccountSettingsSubmit),
    definition: {
        group: "Account Settings",
        allowedContexts: ["AccountSettingsPage"], // Greif Custom Code
        displayName: "Submit",
        /* Greif Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.showCancelChangesButton,
                editorTemplate: "CheckboxField",
                variant: "toggle",
                defaultValue: false,
                fieldType: "General",
            },
        ],
        /* Greif Custom Code - End */
    },
};

export default widgetModule;
